// extracted by css-extract-rspack-plugin
export default {"Wrapper":"CampaignDetailsSidebar_Wrapper__TzkFE","DetailsContainer":"CampaignDetailsSidebar_DetailsContainer__z7jNf","Cancelled":"CampaignDetailsSidebar_Cancelled__xyOP6"};